import { get, toString } from 'lodash/fp';

import { IN_PROGRESS, SCHEDULED } from '../constants/challengeStatusTypes';

const normalisePlayersCount = entry => {
  if (get('selection_status.players_count', entry)) {
    return get('selection_status.players_count', entry);
  }
  if (get('selection_status.sport_specific.players_count', entry)) {
    const playersCount = get('selection_status.sport_specific.players_count', entry);
    const holesCount = get('selection_status.sport_specific.holes_count', entry);

    return [
      {
        id: SCHEDULED,
        name: 'Scheduled',
        count: get('remaining', holesCount),
        iconType: 'icon-golf-hole'
      },
      {
        id: IN_PROGRESS,
        name: 'In progress',
        count: get('running', playersCount)
      }
    ];
  }
  return undefined;
};

function decodeCompetitor(entry = {}, position) {
  return {
    id: toString(entry.id),
    avatar: get('user.avatar', entry),
    countryImage: get('user.country.flag', entry),
    countryName: get('user.country.name', entry),
    hasWon: entry.won,
    isFriend: !!get('user.is_friend', entry),
    isUltimateChampion: !!get('user.is_king', entry),
    isVIP: !!get('user.is_vip', entry),
    leaderboardPosition: position,
    rank: entry.position,
    rankProjected: entry.projected_position,
    playersCount: normalisePlayersCount(entry),
    prize: get('prize.label', entry),
    prizeProjected: get('projected_prize.label', entry),
    prizeType: get('prize.type', entry),
    prizeValue: get('prize.value', entry),
    score: entry.fantasy_score,
    scoreProjected: entry.projected_score,
    userId: toString(get('user.id', entry)),
    userName: get('user.name', entry)
  };
}

export default decodeCompetitor;
